<section
  class="bg-white dark:bg-gray-900 flex flex-col h-[100%] pt-32 pb-2 md:pt-8 md:pb-8"
>
  <div class="py-8 px-4 mx-auto my-auto max-w-screen-xl lg:py-16 lg:px-6">
    <div class="mx-auto max-w-screen-sm text-center">
      <h1
        class="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-slate-800 dark:text-white"
      >
        404
      </h1>
      <p
        class="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white"
      >
        {{ 'PAGE-NOT-FOUND.TITLE' | translate }}
      </p>
      <p class="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
        {{ 'PAGE-NOT-FOUND.DESCRIPTION' | translate }}
      </p>
      <a
        [routerLink]="['/']"
        class="inline-flex text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900 my-4"
      >
        {{ 'PAGE-NOT-FOUND.BACK-TO-HOME' | translate }}
      </a>
    </div>
  </div>
</section>
